import React, { cloneElement } from "react";
import { IconType } from "react-icons";
import Animated from "./Animated"; // Replace with the correct path to the "Animated" component
import posthog from "posthog-js";

type AnimatedToolsProps = {
  delay: number;
  stepSize: number;
  children: React.ReactElement<React.ComponentProps<IconType>>[];
  iconSize: number;
  className?: string;
};

const AnimatedTools: React.FC<AnimatedToolsProps> = ({
  delay,
  stepSize,
  children,
  iconSize,
  className,
}) => {
  return (
    <div className={className}>
      {children.map((child, index) => (
        <div
          key={index}
          onClick={() => {
            posthog.capture("tech_click", { name: "TODO" }); //todo: add name
          }}
        >
          <Animated delay={delay + index * stepSize}>
            {cloneElement(child, { size: iconSize })}
          </Animated>
        </div>
      ))}
    </div>
  );
};

export default AnimatedTools;
